import { TOKEN_INFO } from '@core/constants/generic.constant';
import { AuthTokenModel } from '@core/models/auth.model';
import Cookies from 'js-cookie';

export default function getHeaders() {
    const getAuthToken = Cookies.get(TOKEN_INFO);
    const authToken = getAuthToken ? JSON.parse(getAuthToken as string) : null;
    let headers: any = {
        'Content-Type': `application/json`,
    };
    if (authToken) {
        headers = {
            Authorization: `Bearer ${authToken}`,
            ...headers,
        };
        return headers;
    }
    return {};
}
